// components/PermissionWrapper.tsx

import { Navigate } from 'react-router';

import { usePremissionContext } from './use-permissions-context';

export const PermissionWrapper = ({
  module,
  children,
}: {
  module: string;
  children: React.ReactNode;
}) => {
  const { hasPermission } = usePremissionContext();

  if (!hasPermission(module)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};
